import { AxiosResponse } from "axios"
import { apiInstance } from "../base"
import { IApiKey, ICreateIntegration, IIntegration, IUpdateApiKey, IUpdateIntegration } from "./types"

export const getApiKey = (): Promise<AxiosResponse<IApiKey>> => {
    return apiInstance.handler.get<IApiKey>('/api-keys')
}

export const recreateApiKey = (): Promise<AxiosResponse<IApiKey>> => {
    return apiInstance.handler.post<IApiKey>('/api-keys/recreate')
}

export const updateApiKey = (data: IUpdateApiKey): Promise<AxiosResponse<IApiKey>> => {
    return apiInstance.handler.put<IApiKey>('/api-keys', data)
}

export const getIntegration = (): Promise<AxiosResponse<IIntegration>> => {
    return apiInstance.handler.get<IIntegration>('/integrations')
}

export const updateIntegration = (data: IUpdateIntegration): Promise<AxiosResponse<IIntegration>> => {
    return apiInstance.handler.put<IIntegration>('/integrations', data)
}

export const createIntegration = (data: ICreateIntegration): Promise<AxiosResponse<IIntegration>> => {
    return apiInstance.handler.post<IIntegration>('/integrations', data)
}

export const deleteIntegration = (): Promise<AxiosResponse<void>> => {
    return apiInstance.handler.delete<void>('/integrations')
}
